import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import VueToastr from "vue-toastr";
import VueSweetalert2 from "vue-sweetalert2";
import DatePicker from "vue2-datepicker";
import VueLodash from "vue-lodash";
import lodash from "lodash"
import VueMask from "v-mask";
import VCalendar from "v-calendar";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import ScrollLoader from "vue-scroll-loader";

function setupUse (Vue) {
  Vue.use(BootstrapVue);
  Vue.use(IconsPlugin);
  Vue.use(CKEditor);
  Vue.use(VueToastr, {
    defaultTimeout: 4000,
    defaultPosition: "toast-top-right",
    defaultProgressBar: true,
  });
  Vue.use(VueSweetalert2);
  Vue.use(DatePicker);
  Vue.use(VueLodash, lodash);
  Vue.use(VueMask);
  Vue.use(VCalendar, {
    componentPrefix: "vc", // Use <vc-calendar /> instead of <v-calendar />
  });
  Vue.use(VueMoment, {
    moment,
  });
  const MyGlobalFunction = {
    install(Vue) {
      (Vue.prototype.dateFormat = (str) => {
        return moment(str).format("MM/DD/YYYY");
      }),
        (Vue.prototype.datetimeFormat = (datetime) => {
          return moment(datetime).format("MM/DD/YYYY hh:mm:ss a");
        }),
        (Vue.prototype.datetimeFormatAmPm = (datetime) => {
          return moment(datetime).format("MM/DD/YYYY hh:mm:ss a");
        }),
        (Vue.prototype.globalSubStr = (str, num) => {
          return str.substring(0, num) + "..";
        }),
        (Vue.prototype.closeBtnLoad = (ref) => {
          const submitButton = this.$refs[ref];
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.disabled = false;
        }),
        (Vue.prototype.loadingButton = (ref) => {
          const submitButton = this.$refs[ref];
          submitButton.disabled = true;
          submitButton.classList.add(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
  };
  Vue.use(ScrollLoader);
  Vue.use(MyGlobalFunction);
};

export default setupUse;
